import React, { createContext, useCallback, useContext, useState } from 'react';
import AlertModal from '../AlertModal';

const AlertContext = createContext({
  showAlert: () => Promise.resolve(),
});

export const useAppAlert = () => useContext(AlertContext);

const AppAlertProvider = ({ children }) => {
  const [alertConfig, setAlertConfig] = useState(null);

  const showAlert = useCallback((config = {}) => {
    return new Promise((resolve) => {
      const dismissible = config.dismissible !== false;

      const handleClose = () => {
        setAlertConfig(null);
        resolve('dismissed');
      };

      const handleConfirm = async () => {
        if (config.onConfirm) {
          await config.onConfirm();
        }
        setAlertConfig(null);
        resolve('confirmed');
      };

      setAlertConfig({
        title: config.title || 'Notice',
        message: config.message || '',
        confirmText: config.confirmText || 'OK',
        variant: config.variant || 'info',
        dismissible,
        onClose: dismissible ? handleClose : undefined,
        onConfirm: handleConfirm,
      });
    });
  }, []);

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alertConfig && (
        <AlertModal
          isOpen
          title={alertConfig.title}
          message={alertConfig.message}
          confirmText={alertConfig.confirmText}
          variant={alertConfig.variant}
          dismissible={alertConfig.dismissible}
          onClose={alertConfig.onClose}
          onConfirm={alertConfig.onConfirm}
        />
      )}
    </AlertContext.Provider>
  );
};

export default AppAlertProvider;
